import { render, staticRenderFns } from "./SelectProvider.vue?vue&type=template&id=2b4451bd&"
import script from "./SelectProvider.vue?vue&type=script&lang=js&"
export * from "./SelectProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports